$(function() {

    'use strict';

    /* globals i18n, moment, $ */

    function generateRanges() {

        var ranges = {},
            availableRanges = [
                ['today', [moment(), moment()]],
                ['yesterday', [moment().subtract(1, 'days'), moment().subtract(1, 'days')]],
                ['last_7_days', [moment().subtract(6, 'days'), moment()]],
                ['last_30_days', [moment().subtract(29, 'days'), moment()]],
                ['this_month', [moment().startOf('month'), moment().endOf('month')]],
                ['last_month', [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]],
                ['next_month', [moment().add(1, 'month').startOf('month'), moment().add(1, 'month').endOf('month')]]
            ];

        availableRanges.forEach(function(range) {
            ranges[i18n.t('date_picker.ranges.' + range[0])] = range[1];
        });

        return ranges;

    }

    /* Date Range Picker */

    var dateRangePicker = $('.daterange');

    if (dateRangePicker.length) {

        var dateRanges = generateRanges();

        dateRangePicker.daterangepicker(
            {
                autoUpdateInput: false,
                showISOWeekNumbers: true,
                ranges: dateRanges,
                locale: {
                    format: i18n.t('date_picker.format.date'),
                    applyLabel: i18n.t('date_picker.apply'),
                    cancelLabel: i18n.t('date_picker.cancel'),
                    customRangeLabel: i18n.t('date_picker.custom_range')
                }
            }
        );

        dateRangePicker.on('apply.daterangepicker', function(_, picker) {

            picker.element.siblings('input[type="hidden"]').eq(0).val(picker.startDate.format());
            picker.element.siblings('input[type="hidden"]').eq(1).val(picker.endDate.format()).change();

            picker.element.val(picker.startDate.format('L') + ' - ' + picker.endDate.format('L'));

        });

        dateRangePicker.on('cancel.daterangepicker', function(_, picker) {

            picker.element.siblings('input[type="hidden"]').eq(0).val('');
            picker.element.siblings('input[type="hidden"]').eq(1).val('').change();

            picker.element.val('');

        });

        dateRangePicker.each(function(i, element) {

            var picker = $(element),
                startDate = picker.siblings('input[type="hidden"]').eq(0).val(),
                endDate = picker.siblings('input[type="hidden"]').eq(1).val();

            if(startDate === '') {
                return;
            }

            picker.data('daterangepicker').setStartDate(moment(startDate));
            picker.data('daterangepicker').setEndDate(moment(endDate));

            picker.val(moment(startDate).format('L') + ' - ' + moment(endDate).format('L'));

        });

        dateRangePicker.on('keyup', function() {

            var input = $(this);

            if(input.val().length === 0) {
                input.siblings('input[type="hidden"]').eq(0).val('');
                input.siblings('input[type="hidden"]').eq(1).val('');
            }

        });

    }

    /* Single Date Picker */

    function initializeDatePicker() {

        var datePicker = $('.datepicker'),
            format = datePicker.data('with-format') || 'date',
            withTime = datePicker.is('[data-with-time]'),
            minDate = datePicker.data('min-date') || 15,
            maxDate = datePicker.data('max-date') || 20;

        if (datePicker.length) {

            var configuration = {
                singleDatePicker: true,
                showDropdowns: true,
                showISOWeekNumbers: true,
                autoUpdateInput: false,
                minDate: moment().subtract(minDate, 'years'),
                maxDate: moment().add(maxDate, 'years'),
                locale: {
                    format: i18n.t('date_picker.format.' + format),
                    applyLabel: i18n.t('date_picker.apply'),
                    cancelLabel: i18n.t('date_picker.cancel')
                }
            };

            if(withTime) {

                configuration.timePicker = withTime;
                configuration.timePicker24Hour = true;

            }

            datePicker.daterangepicker(configuration);

            datePicker.on('apply.daterangepicker', function(_, picker) {

                var format = 'DD.MM.YYYY';

                if(withTime) {
                    format = format + ' HH:mm';
                }

                picker.element.val(moment(picker.startDate).format(format));

            });

        }

    }

    initializeDatePicker();

    $('body').on('modal:show', function() {
        initializeDatePicker();
    });

});
